<template>
    <div class="invoice_box">
      <p style="color: red;margin: .2rem 0;">{{system.info}}</p>
      <h3>发票类型</h3>
      <yd-radio-group v-model="invoice.type" class="radio_box">
        <yd-radio v-for="(i,key) in system.invoicetype" :val="key" :key="key">{{i}}</yd-radio>
      </yd-radio-group>

      <h3>发票抬头</h3>
      <yd-radio-group v-model="invoice.leixing">
        <yd-radio v-if="(system.InvoiceLeixing === '3' || system.InvoiceLeixing === '1')" val="1">个人</yd-radio>
        <yd-radio v-if="(system.InvoiceLeixing === '3' || system.InvoiceLeixing === '2')" val="2">单位</yd-radio>
      </yd-radio-group>
      <div class="invoice_inf">
        <yd-cell-item>
          <span slot="left"><i style="color: red" v-show="invoiceNameRequire">*</i> 单位名称：</span>
          <input slot="right" type="text" v-model="invoice.name" class="input_height" placeholder="请输入单位名称">
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left"><i style="color: red" v-show="invoiceShuinoRequire">*</i> 纳税人识别码：</span>
          <input slot="right" type="text" v-model="invoice.shuino" class="input_height" placeholder="请输入纳税人识别码">
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left"><i style="color: red" v-show="invoiceZzaddressRequire">*</i> 单位地址：</span>
          <input slot="right" type="text" class="input_height" v-model="invoice.zzaddress" placeholder="请输入单位地址">
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left"><i style="color: red" v-show="invoiceZzphoneRequire">*</i> 电话号码：</span>
          <input slot="right" type="text" class="input_height" v-model="invoice.zzphone" placeholder="请输入电话号码">
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left"><i style="color: red" v-show="invoiceZzbankRequire">*</i> 开户银行：</span>
          <input slot="right" type="text" class="input_height" v-model="invoice.zzbank" placeholder="请输入开户银行">
        </yd-cell-item>
        <yd-cell-item>
          <span slot="left"><i style="color: red" v-show="invoiceZzaccountRequire">*</i> 银行账户：</span>
          <input slot="right" type="text" class="input_height" v-model="invoice.zzaccount" placeholder="请输入银行账户">
        </yd-cell-item>
        <yd-radio-group v-model="invoice.content">
          <h3>开票内容</h3>
          <yd-radio v-for="(i,key) in system.invoice_content" :key="key" :val="key" >{{i}}</yd-radio>
        </yd-radio-group>
        <yd-radio-group v-show="(system.separate === '1')" v-model="invoice.way">
          <h3>分开开票</h3>
          <yd-radio val="1">开一张发票</yd-radio>
          <yd-radio val="2">分开开票</yd-radio>
        </yd-radio-group>
        <div v-if="system.invoicemail === '1'">
          <h3 slot="left">邮递</h3>
          <yd-switch v-model="invoice.needmail"></yd-switch>
        </div>
        <div v-show="invoiceLxrRequire || invoiceMobileRequire || invoiceEmailRequire || invoicePcdRequire || invoiceAddressRequire">
            <h3>收票人信息</h3>
            <yd-cell-item v-show="invoiceLxrRequire">
              <span slot="left"><i style="color: red" v-show="invoiceLxrRequire">*</i> 收票人姓名：</span>
              <input slot="right" type="text" class="input_height" v-model="invoice.lxr" placeholder="请输入收票人姓名">
            </yd-cell-item>
            <yd-cell-item v-show="invoiceMobileRequire">
              <span slot="left"><i style="color: red" v-show="invoiceMobileRequire">*</i> 收票人手机：</span>
              <input slot="right" type="text" class="input_height" v-model="invoice.mobile" placeholder="请输入收票人手机">
            </yd-cell-item>
            <yd-cell-item v-show="invoiceEmailRequire">
              <span slot="left"><i style="color: red" v-show="invoiceEmailRequire">*</i> 收票人邮箱：</span>
              <input slot="right" type="text" class="input_height" v-model="invoice.email" placeholder="请输入收票人邮箱">
            </yd-cell-item>
            <yd-cell-item arrow v-show="invoicePcdRequire">
              <span slot="left"><i style="color: red" v-show="invoicePcdRequire">*</i> 所在地区：</span>
              <input slot="right" type="text" @click.stop="cityShow = true" class="input_height" v-model="pcd" readonly
                     placeholder="请选择省市县">
            </yd-cell-item>
            <yd-cityselect v-model="cityShow"
                           :callback="result1"
                           :provance="this.invoice.province"
                           :city="this.invoice.city"
                           :area="this.invoice.dist"
                           :items="district"
            ></yd-cityselect>
            <yd-cell-item v-show="invoiceAddressRequire">
              <span slot="left"><i style="color: red" v-show="invoiceAddressRequire">*</i> 详细地址：</span>
              <input slot="right" type="text" v-model="invoice.address" class="input_height" placeholder="请输入详细地址">
            </yd-cell-item>
          </div>
        <yd-button size="large" type="primary" @click.native="submitInvoice">确定</yd-button>
      </div>
    </div>
</template>

<script type="text/babel">
import axios from 'axios'
import {CitySelect} from 'vue-ydui/dist/lib.rem/cityselect'
import District from 'ydui-district/dist/gov_province_city_area_id'
import Vue from 'vue'
Vue.component(CitySelect.name, CitySelect)

export default {
  name: 'InvoiceUpdate',
  data () {
    return {
      system: {},
      cityShow: false,
      pcd: '',
      district: District,
      invoice: {
        'type': '',
        'content': 1,
        'way': 1,
        'leixing': '',
        'lxr': '',
        'mobile': '',
        'province': '',
        'city': '',
        'dist': '',
        'address': '',
        'name': '',
        'shuino': '',
        'zzaccount': '',
        'zzbank': '',
        'zzphone': '',
        'zzaddress': '',
        'email': '',
        'needmail': 0
      },
      invoiceNameRequire: true,
      invoiceShuinoRequire: true,
      invoiceZzaddressRequire: false,
      invoiceZzphoneRequire: false,
      invoiceZzbankRequire: false,
      invoiceZzaccountRequire: false,
      invoiceAddressRequire: false,
      invoicePcdRequire: false,
      invoiceEmailRequire: false,
      invoiceMobileRequire: false,
      invoiceLxrRequire: false,
      token: this.$store.state.token,
      params: this.$route.params
    }
  },
  methods: {
    getIncoice () {
      let data = {
        invid: this.params.invid
      }
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/fair/invoview', data)
        .then(res => {
          res = res.data
          if (res.status) {
            this.invoice = res.data
            if (this.invoice.needmail === '1') {
              this.invoice.needmail = true
            }
            this.updatepcd()
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    getInvoiceSetting () {
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/fair/invoice-setting', {id: this.params.invid})
        .then(res => {
          res = res.data
          if (res.status) {
            this.system = res.data.system
            if (this.system.invoicemail === '2') {
              this.invoice.needmail = true
            }
            this.getIncoice()
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    checkInvoiceRequire () {
      this.invoiceEmailRequire = false
      if (this.invoice.type === '1') {
        this.invoiceNameRequire = true
        this.invoiceZzaddressRequire = false
        this.invoiceZzphoneRequire = false
        this.invoiceZzbankRequire = false
        this.invoiceZzaccountRequire = false
      } else if (this.invoice.type === '2') {
        this.invoiceNameRequire = true
        this.invoiceZzaddressRequire = false
        this.invoiceZzphoneRequire = false
        this.invoiceZzbankRequire = false
        this.invoiceZzaccountRequire = false
        this.invoiceEmailRequire = true
      } else if (this.invoice.type === '3') {
        this.invoiceNameRequire = true
        this.invoiceShuinoRequire = true
        this.invoiceZzaddressRequire = true
        this.invoiceZzphoneRequire = true
        this.invoiceZzbankRequire = true
        this.invoiceZzaccountRequire = true
      }
      if (this.invoice.leixing === '1' && this.invoice.type !== '3') {
        this.invoiceShuinoRequire = false
      } else {
        this.invoiceShuinoRequire = true
      }
      if (this.invoice.needmail === true) {
        this.invoiceLxrRequire = true
        this.invoicePcdRequire = true
        this.invoiceMobileRequire = true
        this.invoiceAddressRequire = true
      } else {
        this.invoiceLxrRequire = false
        this.invoicePcdRequire = false
        this.invoiceMobileRequire = false
        this.invoiceAddressRequire = false
      }
    },
    checkInvoice () {
      if (this.iskai) {
        if (this.invoice.type === '') {
          this.$dialog.toast({
            mes: '发票类型必填'
          })
          return false
        }
        if (this.invoice.leixing === '') {
          this.$dialog.toast({
            mes: '发票抬头类别必填'
          })
          return false
        }
        if (this.invoiceNameRequire) {
          if (this.invoice.name === '' || this.invoice.name.length <= 0) {
            this.$dialog.toast({
              mes: '发票名称必填'
            })
            return false
          }
        }
        if (this.invoiceShuinoRequire) {
          if (this.invoice.shuino === '' || this.invoice.shuino.length <= 0) {
            this.$dialog.toast({
              mes: '发票税号必填'
            })
            return false
          }
        }
        if (this.invoiceZzaddressRequire) {
          if (this.invoice.zzaddress === '' || this.invoice.zzaddress.length <= 0) {
            this.$dialog.toast({
              mes: '单位地址必填'
            })
            return false
          }
        }
        if (this.invoiceZzphoneRequire) {
          if (this.invoice.zzphone === '' || this.invoice.zzphone.length <= 0) {
            this.$dialog.toast({
              mes: '电话号码必填'
            })
            return false
          }
        }
        if (this.invoiceZzbankRequire) {
          if (this.invoice.zzbank === '' || this.invoice.zzbank.length <= 0) {
            this.$dialog.toast({
              mes: '开户银行必填'
            })
            return false
          }
        }
        if (this.invoiceZzaccountRequire) {
          if (this.invoice.zzaccount === '' || this.invoice.zzaccount.length <= 0) {
            this.$dialog.toast({
              mes: '银行账户必填'
            })
            return false
          }
        }
        if (this.invoiceLxrRequire) {
          if (this.invoice.lxr === '' || this.invoice.lxr.length <= 0) {
            this.$dialog.toast({
              mes: '收件人姓名必填'
            })
            return false
          }
        }
        if (this.invoiceMobileRequire) {
          if (this.invoice.mobile === '' || this.invoice.mobile.length <= 0) {
            this.$dialog.toast({
              mes: '收件人手机号必填'
            })
            return false
          }
        }
        if (this.invoiceEmailRequire) {
          if (this.invoice.email === '' || this.invoice.email.length <= 0) {
            this.$dialog.toast({
              mes: '收件人邮箱必填'
            })
            return false
          }
        }
        if (this.invoicePcdRequire) {
          if (this.invoice.province === '' || this.invoice.province.length <= 0 || this.invoice.city === '' || this.invoice.city.length <= 0 || this.invoice.dist === '' || this.invoice.dist.length <= 0) {
            this.$dialog.toast({
              mes: '收件人省市县必填'
            })
            return false
          }
        }
        if (this.invoiceAddressRequire) {
          if (this.invoice.address === '' || this.invoice.address.length <= 0) {
            this.$dialog.toast({
              mes: '收件人详细地址必填'
            })
            return false
          }
        }
      }
      return true
    },
    result1 (ret) {
      this.pcd = ret.itemName1 + ' ' + ret.itemName2 + ' ' + ret.itemName3
      this.invoice.province = ret.itemValue1
      this.invoice.city = ret.itemValue2
      this.invoice.dist = ret.itemValue3
    },

    submitInvoice () {
      let invoiceRes = this.checkInvoice()
      if (!invoiceRes) {
        this.$dialog.toast({
          mes: '请检查发票信息是否正确'
        })
        return false
      }

      let data = {
        invid: this.params.invid,
        type: this.invoice.type,
        content: this.invoice.content,
        way: this.invoice.way,
        leixing: this.invoice.leixing,
        lxr: this.invoice.lxr,
        mobile: this.invoice.mobile,
        province: this.invoice.province,
        city: this.invoice.city,
        dist: this.invoice.dist,
        address: this.invoice.address,
        name: this.invoice.name,
        shuino: this.invoice.shuino,
        zzaccount: this.invoice.zzaccount,
        zzbank: this.invoice.zzbank,
        zzphone: this.invoice.zzphone,
        zzaddress: this.invoice.zzaddress,
        email: this.invoice.email,
        needmail: this.invoice.needmail
      }
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/fair/invo-uplode', data)
        .then(this.submitInvoiceSucc)
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    submitInvoiceSucc (res) {
      res = res.data
      if (res.status === 1) {
        this.$dialog.toast({
          mes: '修改成功'
        })
        this.$router.push({path: '/' + this.params.id + '/invoice-detail/' + this.params.invid})
      } else {
        this.$dialog.toast({
          mes: res.msg
        })
      }
    },
    updatepcd () { // 默认地址、 赋值
      let p = ''
      let c = ''
      let d = ''
      District.forEach(item => {
        if (item.v === this.invoice.province) {
          p = item.n
          item.c.forEach(itemc => {
            if (itemc.v === this.invoice.city) {
              c = itemc.n
              itemc.c.forEach(ic => {
                if (ic.v === this.invoice.dist) {
                  d = ic.n
                }
              })
            }
          })
        }
      })
      this.pcd = p + ' ' + c + ' ' + d
    },
    checkLogin () {
      if (!this.$store.state.uid) {
        this.$router.push({path: '/' + this.params.id + '/single-my'})
      }
    }
  },
  mounted () {
    this.checkLogin()
    this.getInvoiceSetting()
  },
  watch: {
    'invoice.type': function () {
      this.checkInvoiceRequire()
    },
    'invoice.leixing': function () {
      this.checkInvoiceRequire()
    },
    'invoice.needmail': function () {
      this.checkInvoiceRequire()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .invoice_box
    background-color: #FFFFFF
    color: black
    padding: .2rem .4rem
  .invoice_box>:first-child
    margin: 0
  h3
    margin-top: .3rem
    margin-bottom: .1rem
    color: black
    font-size: .32rem
  .radio_box>:last-child
    padding: 0
</style>



// WEBPACK FOOTER //
// src/views/template1/InvoiceUpdate.vue